import { useQuery } from '@tanstack/react-query';
import {
  getAdminCatalog,
  CatalogItem,
} from '@/services/admin/get-admin-catalog';

export const useGetAdminCatalog = () => {
  return useQuery<CatalogItem[]>({
    queryKey: ['admin-catalog'],
    queryFn: getAdminCatalog,
  });
};
